import { combinable } from './combos';
export const checkForXSAreas = (items) => {
  // Get the count of all XS areas if any
  const xs_areas = items.filter((area) => area.size === 'XS');
  const actual_xs_areas_count = xs_areas.length;

  // ***** UNIQUE SITUATION ***** //
  // Full Face & Neck Count
  let ffn_areas_count = 0;
  // Full Face & Neck is a combination of 7 XS areas ['unibrow', 'upper_lip', 'chin', 'cheeks', 'neck', 'sideburns', 'jawline']
  // Selecting 3 or more children of FFN must not exceed the parent's time of 20 minutes
  if (actual_xs_areas_count >= 3) {
    const FFN = combinable.find(
      (elem) => elem.parentId === 'full_face_and_neck'
    );
    const ffn_areas = xs_areas.filter((area) =>
      FFN.childrenIds.includes(area.id)
    );
    ffn_areas_count = ffn_areas.length;
  }

  let adjusted_xs_areas_count =
    ffn_areas_count >= 3
      ? actual_xs_areas_count - ffn_areas_count + 3 // This would treat the FFN as 3 xs areas
      : actual_xs_areas_count;

  const are_all_items_xs = items.length === actual_xs_areas_count;

  return {
    adjusted_xs_areas_count,
    are_all_items_xs,
  };
};
